/*
 * Snapshot nội dung Content Hub (kéo bằng `npm run cms:pull`, bundle lúc build) — một
 * accessor dùng chung cho content.server.js, module scan/help/pháp lý, worker và Next.
 * `setCmsSnapshotForTests` cho script check thay snapshot mà không phải ghi file.
 */
import bundledSnapshot from "../redesign/cmsSiteContent.generated.json";

let current = bundledSnapshot;

export const getCmsSnapshot = () => current;

export const setCmsSnapshotForTests = (next) => {
  current = next || bundledSnapshot;
};
